import { render, staticRenderFns } from "./TopUpModal.vue?vue&type=template&id=20659644&scoped=true"
import script from "./TopUpModal.vue?vue&type=script&lang=js"
export * from "./TopUpModal.vue?vue&type=script&lang=js"
import style0 from "./TopUpModal.vue?vue&type=style&index=0&id=20659644&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20659644",
  null
  
)

export default component.exports